import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '../components/UI/base/Button';
import styles from './ErrorPage.module.css';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <main className={styles.errorPage}>
      <h1 className={styles.message}>{t('error-page-message')}</h1>
      <Button type="primary" onClick={handleGoBack}>
        {t('error-page-go-back')}
      </Button>
    </main>
  );
};
